import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { IconContainer, ContentContainer, TriggerText } from './Expando.styles';
var Expando = function (props) {
    var title = props.title, children = props.children, Icon = props.Icon, id = props.id, defaultExpanded = props.defaultExpanded;
    var _a = useState(defaultExpanded || false), open = _a[0], setOpen = _a[1];
    return (React.createElement(Accordion, { elevation: 2, defaultExpanded: defaultExpanded || false, onChange: function (evt, expanded) {
            setOpen(expanded);
        } },
        React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null), "aria-controls": "".concat(id, "-controls"), id: id },
            React.createElement(React.Fragment, null,
                Icon && React.createElement(IconContainer, null, React.createElement(Icon, null)),
                React.createElement(Typography, { sx: TriggerText.text }, title))),
        React.createElement(AccordionDetails, null,
            React.createElement(ContentContainer, { open: open }, children))));
};
export default Expando;
